import SectionTitle from "@/components/ui/section-title";
import { SafeHTML } from "@/utils/constants";

const Dummy_Sec = ({ beforeFooterSection }) => {

  return (
    <section className="container cutome-content-box">
      <SectionTitle
        title={beforeFooterSection.title}
        customClass={"text-center mb-5 lg:mb-[2vw]"}
        tag={'div'}
      />

      {beforeFooterSection.description ?
        <SafeHTML html={beforeFooterSection.description} className="text-center" />
        : null
      }
    </section>
  );
};

export default Dummy_Sec;
